import type { MetricName, Source } from "./types";
export function sourceSelection(
  source: Source,
  params: URLSearchParams,
  breakdowns: string[] = [],
) {
  const search = source === "gsc";
  const metrics: MetricName[] = search
    ? ["clicks", "impressions", "ctr", "position"]
    : ["sessions", "users", "pageviews"];
  const requested = params.get("metric") as MetricName;
  const metric = metrics.includes(requested) ? requested : metrics[0];
  const options = [
    { id: search ? "queries" : "pages", label: search ? "Queries" : "Pages" },
    ...(search ? [{ id: "pages", label: "Pages" }] : []),
    { id: "countries", label: "Countries" },
    ...(!search && breakdowns.some((v) => v.toLowerCase().includes("device"))
      ? [{ id: "devices", label: "Devices" }]
      : []),
  ];
  const view = options.some((o) => o.id === params.get("view"))
    ? params.get("view")!
    : options[0].id;
  return {
    metrics,
    metric,
    view,
    options,
    report: `${search ? "search" : "traffic"}-${view}`,
  };
}
